// src/components/molecules/FormFields/DescriptionInput.js
import React from "react";
import { Typography, Box } from "@mui/material";
import { useTheme } from "styled-components";

const DescriptionInput = ({ value, onChange, error, disabled }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="body1"
        component="label"
        htmlFor="description"
        sx={{ fontFamily: "basic-sans", color: "white" }}
      >
        Add a short description of your submission
      </Typography>
      <textarea
        id="description"
        name="description"
        rows={4}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          width: "100%",
          padding: "10px",
          marginTop: "8px",
          fontFamily: "basic-sans",
          fontWeight: "normal",
          backgroundColor: disabled ? "#f0f0f0" : "white",
          borderRadius: "5px",
          border: error ? `1px solid ${theme.colors.red}` : "1px solid #ccc",
          color: disabled ? theme.colors.gray : "black",
          resize: "vertical", // Allow vertical resizing when not disabled
        }}
      />
      {error && (
        <Typography
          variant="body2"
          sx={{
            color: theme.colors.red,
            mt: 1,
            fontFamily: "basic-sans",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default DescriptionInput;
